export { Root } from './components/Root';
export { QueryClientWrapper as Upload } from './components/UploadLegacy';
export * as PATHS from './constants/paths';
export { close as closeUploadModal, open as openUploadModal } from './stores/upload';
export const HASH = import.meta.env.VITE_BUILD_HASH ?? 'UNKNOWN';
import '@skand/ui/style.css';
